import clsx from "clsx";
import React from "react";

export type ButtonProps<T extends React.ElementType> = {
  as?: T;
  transparent?: boolean;
} & React.ComponentProps<T>;

export const Button = <T extends React.ElementType = "button">({
  as: Element = "button",
  children,
  className,
  transparent = true,
  ...props
}: ButtonProps<T>) => {
  return (
    <Element
      className={clsx(
        "inline-flex items-center gap-2 rounded-lg border px-4 py-1.5 [-webkit-tap-highlight-color:transparent] disabled:cursor-not-allowed",
        "transition-transition-[background-color,border-color] border-primary-12/20 hover:bg-primary-6/40 dark:border-primary-1 dark:bg-primary-2/80 dark:hover:bg-primary-6/40 duration-100 disabled:bg-neutral-300/80 disabled:text-gray-400",
        transparent ? "bg-primary-3/40" : "bg-primary-1/40",
        className,
      )}
      type={props.type ?? "button"}
      {...props}
    >
      {children}
    </Element>
  );
};
